import { useState } from "react"

export const VariableReport =() => {
    const [state, setState] = useState({
        type_id: '',
        type_name: '',
        date:"",
        account_id:'',
        account_name:'',
        Load: false,
    })
    const setStateCustom = (variableName, value) => {
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
  return {
    ...state,
    state,
    setState,
    setStateCustom,
    setLoad
  }
}

